import { apiJson } from "@/lib/api";

/** Shared stale window for `/events/live` — reduces repeat refetches when switching tabs (default RQ staleTime is 5s). */
export const LIVE_EVENTS_STALE_MS = 60_000;

export type LiveEventPayload = {
  id?: string;
  key?: string;
  rules: Record<string, unknown>;
  endsAt?: string | Date | null;
  startsAt?: string | Date | null;
};

export function liveEventsQueryKey(token: string | null | undefined) {
  return ["events", "live", token] as const;
}

export function fetchLiveEvents(token: string) {
  return apiJson<{ events: LiveEventPayload[] }>("/events/live", { token });
}
